import React, { useEffect, useCallback } from 'react';
import { useDispatch } from "react-redux";
import Modal from 'react-modal';
import Select from 'react-select';
import { Input, message } from 'antd';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import './index.css';
import { setItemData } from '../../../../store/actions/customers/customers';
import Loading from "../../screen/loading";
import { customStyles, customStylesSelector } from './style';

const { TextArea } = Input;

const NoteModal = ({
      isNoteModalOpen,
      setNoteModalIsOpen,
      rowState,
      hasError,
      actionMessage,
      loading,
      resetError,
      header,
      priceTemplateType,
    }) => {

  const dispatch = useDispatch();
  const resource = "OrderResources";
  let submitAction = '';
  const notes = rowState.data.notes;

  const pickLocationsListOptions = [
    { value: 'pickLocation', label: 'Pick Location' },
    { value: 'dropLocation', label: 'Drop Location' },
    { value: 'pickAppt', label: 'Pick Appt' },
    { value: 'dropAppt', label: 'Drop Appt' },
    { value: 'other', label: 'Other' },
  ];

  const getLabel = useCallback((location) => {
    const option = pickLocationsListOptions.filter(item => item.value === location)[0];
    return option.label;
  }, [pickLocationsListOptions]);

  const validationSchema = Yup.object().shape({
    location: Yup.string().required('Location is required'),
    note: Yup.string().required('Note is required'),
  });

  const closeModal = () => {
    setTimeout(() => {
      setNoteModalIsOpen(false);
    }, 1000)
  };

  useEffect(() => {
    if (hasError) {
        message.error(actionMessage);
        dispatch(resetError(resource));
    }
  }, [hasError, actionMessage, resetError, resource, dispatch]);

  const handleChange  = useCallback((fieldName, value, setFieldValue) => { 
    setFieldValue(fieldName, value);
    setFieldValue('note', notes?.find(note => note.name === value)?.description);
  }, [notes]);

  const handleSave = useCallback((values) => {
    let newNotesList = [];
    const isNewField = rowState?.data?.notes?.filter(note => note.name === values.location).length < 1;
    if (isNewField) {
      const newNote = {
        name: values.location,
        description: values.note,
      };
      newNotesList = [...notes, newNote];
    } else {
      newNotesList = rowState?.data?.notes?.map(note => {
          if (note.name === values.location) {
            note.description = values.note;
          }
          return note;
      })
    }
    dispatch(setItemData(resource, newNotesList, rowState, header, priceTemplateType));  
  }, [dispatch, header, notes, priceTemplateType, rowState]);

  return (
    <Modal
        isOpen={isNoteModalOpen}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
        >
        <div className='note_modal__container'>
          {loading ? <Loading /> : <>
            <div className='note_modal__x-btn' onClick={closeModal}>X</div>
            <div className='note_modal_text'>NOTES</div>
            <hr className='notes-price__hr'></hr>
            <Formik
              initialValues={{ location: '', note: notes }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm, setSubmitting, setFieldValue, errors }) => {
                  handleSave(values);
                  setSubmitting(false);
                  if (submitAction === 'back') {
                    setTimeout(() => {
                      setNoteModalIsOpen(false);
                    }, 1000)
                  }
              }}
              >
              {({ isSubmitting, isValid, values, setFieldValue, errors, touched, handleSubmit }) => {
                return (
                  <Form style={{ width: '100%' }}>      
                      <div className='add-note__container'>
                        <div className='price-modal__add_new'>Location</div>
                        <Field name="location">
                          {({ field }) => (
                            <Select
                              {...field}
                              value={values.location && { label: values.location && getLabel(values.location) }}
                              options={pickLocationsListOptions}
                              placeholder="Select Location"
                              onChange={(option) => handleChange('location', option.value, setFieldValue)}
                              styles={customStylesSelector}
                              components={{ IndicatorSeparator: () => null }}
                            />
                          )}
                        </Field>
                        <div className='price-modal__add_new'>Notes</div>
                        <Field name="note">
                          {({ field }) => (
                            <TextArea
                              {...field}
                              value={Array.isArray(values?.note) ? '' : values.note}
                              placeholder="Comment"
                              autoSize={{ minRows: 2, maxRows: 6 }}
                              className="price-note__textArea"
                            />
                          )}
                        </Field>
                      </div>        
                      <div className='price-buttons__container'>
                          <button 
                              type="submit"
                              className={`price-button ${(!values.location || !values.note) && 'price-button-disabled'} `} 
                              disabled={!values.location || !values.note || isSubmitting}
                              onClick={() => {
                                submitAction = 'save';
                              }}>
                              Save
                          </button>
                          <button
                              type="submit"
                              className={`price-button ${(!values.location || !values.note) && 'price-button-disabled'} `} 
                              disabled={!values.location || !values.note || isSubmitting}
                              onClick={() => {
                                submitAction = 'back';
                              }}>
                              Save & Back
                          </button>
                          <separator className='customerOrder-admin__separator' vertical=''></separator>
                          <button
                              type="submit"
                              className={'price-button price-button__cancel'}
                              onClick={closeModal}>
                              Cancel
                          </button>
                      </div>
                  </Form>
                );
              }}
            </Formik>
          </>}
        </div>  
    </Modal>
  );
};

export default NoteModal;
